module.exports = __webpack_public_path__ + "static/media/student-score-side.5624be5a.png";